import { Typography } from '@mui/material'
import {
  ChevronRightMinor,
  CircleAlertMajor,
  CircleCancelMajor,
  CircleTickMajor,
} from '@shopify/polaris-icons'
import tw from 'twin.macro'

type InfoContainerColor = 'purple' | 'orange' | 'success' | 'error'

export interface InfoContainerProps {
  children?: React.ReactNode
  className?: any
  color?: InfoContainerColor
  actionText?: string
  onClick?(): void
}

const containerStyles = {
  purple: tw`bg-primary-100`,
  orange: tw`bg-warning-200`,
  success: tw`bg-success-200`,
  error: tw`bg-critical-50`,
}

const containerHoverStyles = {
  purple: tw`bg-primary-100 hover:bg-primary-200 cursor-pointer`,
  orange: tw`cursor-pointer`,
  success: tw`cursor-pointer`,
  error: tw`bg-critical-50 cursor-pointer`,
}

const textStyles = {
  purple: tw`text-primary-500`,
  orange: tw`text-warning-500`,
  success: tw`text-success-500`,
  error: tw`text-critical-500`,
}

const iconStyles = {
  purple: tw`fill-primary-500`,
  orange: tw`fill-warning-500`,
  success: tw`fill-success-500`,
  error: tw`fill-critical-500`,
}

export const InfoContainer = ({
  children,
  className,
  actionText,
  color = 'purple',
  onClick,
}: InfoContainerProps) => {
  const getIcon = () => {
    if (color === 'success') {
      return <CircleTickMajor width={20} height={20} css={tw`fill-success-500`} />
    }

    if (color === 'error') {
      return <CircleCancelMajor width={20} height={20} css={iconStyles[color]} />
    }

    return <CircleAlertMajor width={20} height={20} css={iconStyles[color]} />
  }

  return (
    <div
      css={[
        tw`p-4 rounded-lg flex flex-row items-center`,
        onClick ? containerHoverStyles[color] : containerStyles[color],
        className,
      ]}
      onClick={onClick}
    >
      <div css={tw`w-5 mr-4 h-5`}>{getIcon()}</div>
      <div css={tw`flex flex-col`}>
        <Typography css={textStyles[color]}>{children}</Typography>
        {actionText && (
          <Typography css={[tw`mt-2`, textStyles[color]]} fontWeight={600}>
            {actionText}
          </Typography>
        )}
      </div>
      {onClick ? (
        <div css={tw`ml-auto h-[20px]`}>
          <ChevronRightMinor width={20} css={iconStyles[color]} />
        </div>
      ) : null}
    </div>
  )
}
